import { BookOpen, CalendarDays, Mail, Music, Users } from "lucide-react";
import type { NavGroupIconName } from "./nav-config";

export const navGroupIcons: Record<
  NavGroupIconName,
  React.ComponentType<{ className?: string; "aria-hidden"?: boolean }>
> = {
  music: Music,
  calendar: CalendarDays,
  users: Users,
  book: BookOpen,
  mail: Mail,
};
